define('threadsListSearchView',[
    'app',
    'module',
    'marionette',
    'template!threadsListSearchView'
], function (
    App,
    Module,
    Marionette,
    Tpl
) {
    'use strict';

    Module.exports = Marionette.LayoutView.extend({
        template: Tpl,
        className: 'search-view',

        ui: {
            input: '.search-input',
            button: '.search-button'
        },

        events: {
            'click @ui.button': 'onSearch',
            'keyup @ui.input': 'onKeyup'
        },

        onSearch: function() {
            var value = this.ui.input.val();
            this.trigger('search', value);
        },

        onKeyup: function(e) {
            if (e.keyCode === 13) {
                this.onSearch();
            }
        },

        clear: function() {
            this.ui.input.val('');
        }
    });
});

